// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload);

import App from './App'
import router from './router'

import Mint from 'mint-ui'
import 'mint-ui/lib/style.min.css'
Vue.use(Mint)

import './assets/scss/wap/wapcommon.scss'
import http from './common/http'
import store from './common/store'
import utils from './common/utils'

Vue.prototype.$http = http;
Vue.prototype.$utils = utils;
utils.initRem();

Vue.directive('fontemojtopic', {
  bind: function (el, binding, vnode) {
    if(binding.value){
      utils.filterEmojTextToImg(binding.value, function(content){
        var content = content.replace(/#.[^#]*#/g, function(item){
          return '<span class="link-jump">'+item+'</span>&nbsp;';
        });
        el.innerHTML = content;
      });
    }
  }
});


new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js